var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5.75C0.75 4.64543 1.64543 3.75 2.75 3.75H21.25C22.3546 3.75 23.25 4.64543 23.25 5.75V19.75C23.25 20.8546 22.3546 21.75 21.25 21.75H2.75C1.64543 21.75 0.75 20.8546 0.75 19.75V5.75Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.419 8L8.287 10.842C8.2225 10.9279 8.14031 10.9989 8.04598 11.0503C7.95165 11.1017 7.84739 11.1322 7.74025 11.1397C7.63311 11.1473 7.52559 11.1318 7.42496 11.0943C7.32434 11.0567 7.23296 10.9979 7.157 10.922L6 9.766",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.419 14.75L8.287 17.592C8.2225 17.6779 8.14031 17.7489 8.04598 17.8003C7.95165 17.8517 7.84739 17.8822 7.74025 17.8898C7.63311 17.8973 7.52559 17.8818 7.42496 17.8443C7.32434 17.8067 7.23296 17.7479 7.157 17.672L6 16.515",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.142H18",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.142H18",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolls);
export default __webpack_public_path__ + "static/media/polls.30ae277da96d0ebfa6dac0b385aa8630.svg";
export { ForwardRef as ReactComponent };